validateFetchPolicy